import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Container, Card, Alert, Spinner } from "react-bootstrap";

const ZohoCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("processing"); // 'processing', 'success', 'error'
  const [message, setMessage] = useState("Processing Zoho authentication...");

  useEffect(() => {
    const success = searchParams.get("success");
    const error = searchParams.get("error");

    if (success === "true") {
      setStatus("success");
      setMessage("Zoho CRM authenticated successfully!");
      // Redirect to settings page after 2.5 seconds
      const timer = setTimeout(() => {
        navigate("/zoho_setting");
      }, 2500);
      return () => clearTimeout(timer);
    } else if (error) {
      setStatus("error");
      setMessage(`Authorization failed: ${decodeURIComponent(error)}`);
    } else {
      setStatus("error");
      setMessage("Invalid callback parameters received.");
    }
  }, [searchParams, navigate]);

  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: "80vh" }}>
      <Card style={{ width: "450px", border: "none", boxShadow: "rgba(0, 0, 0, 0.08) 0px 4px 12px", borderRadius: "12px" }}>
        <Card.Body className="text-center p-5">
          <img
            src="https://admin.watconnect.com/fav.png"
            alt="Logo"
            style={{ width: "60px", marginBottom: "20px" }}
          />
          <h4 className="mb-4" style={{ fontWeight: "600", color: "var(--text-color-2)" }}>Zoho CRM Auth Callback</h4>

          {status === "processing" && (
            <div className="py-4">
              <Spinner animation="border" variant="success" className="mb-3" />
              <p className="text-muted">{message}</p>
            </div>
          )}

          {status === "success" && (
            <div className="py-2">
              <Alert variant="success" className="d-flex align-items-center justify-content-center">
                <i className="fa-solid fa-circle-check fs-4 me-2"></i>
                <span>{message}</span>
              </Alert>
              <p className="text-muted small mt-3">Redirecting you back to settings...</p>
            </div>
          )}

          {status === "error" && (
            <div className="py-2">
              <Alert variant="danger" className="d-flex align-items-center justify-content-center">
                <i className="fa-solid fa-triangle-exclamation fs-4 me-2"></i>
                <span>{message}</span>
              </Alert>
              <button
                className="btn btn-outline-secondary mt-3"
                onClick={() => navigate("/zoho_setting")}
              >
                Go Back to Settings
              </button>
            </div>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ZohoCallback;
